/* NOIRLAB discovery 0.4.2. Local UI only: no requests, storage or profiling. */
(() => {
  "use strict";
  const initialized = new WeakSet();
  const initializeGuides = (root) => {
    root.querySelectorAll("[data-nl-guide]").forEach((widget) => {
      if (initialized.has(widget)) return;
      const choices = Array.from(widget.querySelectorAll("[data-nl-choice]"));
      const title = widget.querySelector("[data-nl-result-title]");
      const copy = widget.querySelector("[data-nl-result-copy]");
      const link = widget.querySelector("[data-nl-result-link]");
      const checklist = widget.querySelector("[data-nl-result-checklist]");
      const reset = widget.querySelector("[data-nl-reset]");
      if (!choices.length || !title || !copy || !link) return;
      initialized.add(widget);
      const initial = {title: title.textContent, copy: copy.textContent, href: link.getAttribute("href"), link: link.textContent};
      choices.forEach((button) => button.addEventListener("click", () => {
        const target = button.dataset.url || "";
        if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:collections\/[a-z0-9-]+|blogs\/poradniki\/[a-z0-9-]+)$/i.test(target)) return;
        choices.forEach((item) => item.setAttribute("aria-pressed", String(item === button)));
        title.textContent = button.dataset.title || "Poznaj kategorię";
        copy.textContent = button.dataset.copy || "Sprawdź parametry konkretnego urządzenia.";
        link.setAttribute("href", target);
        link.textContent = (button.dataset.label || "Otwórz poradnik") + " ↗";
        if (checklist) {
          const template = Array.from(widget.querySelectorAll("template[data-nl-route-template]")).find((item) => item.dataset.nlRouteTemplate === button.dataset.route);
          checklist.replaceChildren(...(template ? [template.content.cloneNode(true)] : []));
          checklist.hidden = !template;
        }
        if (reset) reset.hidden = false;
      }));
      if (reset) reset.addEventListener("click", () => {
        choices.forEach((item) => item.setAttribute("aria-pressed", "false"));
        title.textContent = initial.title; copy.textContent = initial.copy;
        link.setAttribute("href", initial.href); link.textContent = initial.link;
        if (checklist) { checklist.replaceChildren(); checklist.hidden = true; }
        reset.hidden = true;
        choices[0].focus({preventScroll: true});
      });
    });
  };
  initializeGuides(document);
  document.addEventListener("shopify:section:load", (event) => initializeGuides(event.target));
  document.querySelectorAll("[data-nl-menu]").forEach((menu) => {
    menu.addEventListener("keydown", (event) => { if (event.key === "Escape") menu.open = false; });
    menu.querySelectorAll("a").forEach(a => a.addEventListener("click", () => { menu.open = false; }));
  });
})();
